<template>
    <div v-if="loaded">
      <el-table  class="item-table" stripe
            :row-class-name="getClassnameById"
            :data="bulkRegistrations"
            style="width: 100%">
        <el-table-column prop="entityName" label="Entity" min-width="200">
            <template slot-scope="scope">
                <span class="break-word">{{ getEntityName(scope.row) | cap }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="entityType" label="Entity Type" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.entityType | cap }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="numberOfMembers" label="Registered Members" min-width="180">
          <template slot-scope="scope">
            <span>
              <el-tag class="mr-10" type="success">{{ scope.row.registrations.length }}</el-tag>
              <el-button type="text" @click="viewMemberDetails(scope.row)">
                <i class="el-icon-document"></i>
                View Members
              </el-button>
            </span>
          </template>
        </el-table-column>
        <!-- season -->
        <el-table-column prop="season" label="Season" min-width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.season }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="Registered At" min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.createdAt | formatDate }}</span>
          </template>
        </el-table-column>
        <!-- expiration date -->
        <el-table-column prop="expiry" label="Expiration Date" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.expiry | formatDate }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="" min-width="150">
          <template slot-scope="scope">
            <el-button @click="viewMemberDetails(scope.row)">View Details</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <el-dialog  v-if="dialogVisible" :visible.sync="dialogVisible" title="Member Details">
        <el-table class="item-table" :data="viewingBulkRegistration.registrations" style="width: 100%">
          <el-table-column prop="member.profile.firstName" label="First Name"></el-table-column>
          <el-table-column prop="member.profile.lastName" label="Last Name"></el-table-column>
          <el-table-column prop="member.profile.dob" label="Date of Birth"></el-table-column>
          <el-table-column prop="member.profile.gender" label="Gender"></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">Close</el-button>
        </span>
      </el-dialog>
    </div>
  </template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import _ from 'lodash';

export default {
  data() {
    return {
      bulkRegistrations: [],
      loaded: false,
      dialogVisible: false,
      viewingBulkRegistration: undefined
    };
  },
  computed: {
    ...mapGetters('user', ['userId'])
  },
  async created() {
    await this.getBulkRegistrations();
  },
  methods: {
    async getBulkRegistrations() {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      try {
        const response = await this.$http.get(`/assemble/api/v1/portal/bulk-registrations/user/${this.userId}`);
        this.bulkRegistrations = response.data.data;
        this.loaded = true;
        this.$store.commit('loading', { loading: false, text: '' });
      } catch (error) {
        console.error('Error fetching bulk registrations:', error);
        this.loaded = true;
        this.$store.commit('loading', { loading: false, text: '' });
      }
    },
    getEntityName(row) {
      const { entityType, event, membership } = row;
      console.log('entityType', entityType);
      console.log('event', event);
      console.log('membership', membership);
      console.log('row', row);
      let foundProduct;
      if (entityType === 'event') {
        foundProduct = event.products.find((product) => product._id === row.productId);
      } else if (entityType === 'membership') {
        foundProduct = membership.products.find((product) => product._id === row.productId);
      }

      console.log(foundProduct);
      if (foundProduct && foundProduct.name) {
        return foundProduct.name;
      }
      return row[entityType].name;
    },
    viewMemberDetails(row) {
      this.viewingBulkRegistration = row;
      this.dialogVisible = true;
    }
  },
  filters: {
    cap(value) {
      return _.capitalize(value);
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  }
};
</script>

  <style lang="scss" scoped>
::v-deep .item-table {
  border: 1px solid rgba(45, 58, 69, 0.1);

  th {
    background: #f6f8fa !important;
    padding-right: 1em;
    text-align: left;
  }

  td {
    background-color: white !important;
    text-align: left;
  }
}
  </style>
